import { useState } from 'react'
import { apiSubmitCustomerEnquiry } from '../../api/enquiries/enquiryApi'

type FeatureItem = {
  title: string
  description: string
  icon: string
}

const keyFeatures: FeatureItem[] = [
  {
    title: 'Safety First',
    description:
      'Your safety is our highest priority, from vehicle maintenance to driver training.',
    icon: '/assets/images/image 36.png',
  },
  {
    title: 'Reliability',
    description:
      'Dependable service you can trust for every journey.',
    icon: '/assets/images/Black.png',
  },
  {
    title: 'Comfort',
    description:
      'Modern vehicles designed for a relaxing travel experience.',
    icon: '/assets/images/image 263 (traced).png',
  },
  {
    title: 'Reasonable Rates',
    description:
      'We can offer you the right vehicle at the right price to fit your budget.',
    icon: '/assets/images/image 39.png',
  },
]

export default function KeyFeatures() {
  const [submissionMessage, setSubmissionMessage] = useState<string | null>(null)
  const [submissionError, setSubmissionError] = useState<string | null>(null)

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setSubmissionMessage(null)
    setSubmissionError(null)

    const form = event.currentTarget
    const formData = new FormData(form)
    const result = await apiSubmitCustomerEnquiry({
      customer_name: String(formData.get('name') || '').trim(),
      customer_email: String(formData.get('email') || '').trim(),
      customer_phone: String(formData.get('phone') || '').trim(),
      message: String(formData.get('message') || '').trim(),
    })

    if (result.success) {
      form.reset()
      setSubmissionMessage(result.message)
      return
    }

    setSubmissionError(result.message)
  }

  return (
    <section className="w-full overflow-hidden">
      <div className="grid w-full lg:grid-cols-2">
        
        <div className="flex bg-[#B9D97C] px-5 py-12 sm:px-10 lg:min-h-[620px] lg:px-16 lg:py-12 xl:px-[95px]">
          <div className="mx-auto w-full max-w-[440px] self-center">
            <span className="inline-flex rounded-full bg-white px-3 py-[5px] font-poppins text-[10px] font-medium text-[#FF6B2C]">
              Key Features
            </span>

            <h2 className="mt-5 font-host text-[32px] font-semibold leading-[1.22] tracking-[-0.04em] text-black sm:text-[38px] lg:text-[40px]">
              Make Your Trip
              <span className="block">Your Way With Us</span>
            </h2>

            <div className="mt-5 flex flex-col gap-[11px]">
              {keyFeatures.map((feature) => (
                <div
                  key={feature.title}
                  className="relative min-h-[88px] overflow-hidden rounded-[12px] bg-white px-4 py-3 pr-[96px]"
                >
                  <h3 className="font-host text-[17px] font-semibold leading-tight tracking-[-0.025em] text-black">
                    {feature.title}
                  </h3>

                  <p className="mt-2 max-w-[275px] font-poppins text-[12px] font-normal leading-[1.5] text-[#9A9A9A] sm:text-[13px]">
                    {feature.description}
                  </p>

                  <div className="absolute bottom-0 right-0 top-0 flex w-[96px] items-center justify-center rounded-l-[55%] bg-[#EEEEEE]">
  <div className="relative flex h-[48px] w-[48px] items-center justify-center">
    
    <span className="absolute h-[43px] w-[43px] translate-x-[5px] translate-y-[5px] rounded-full bg-[#9AC53D]" />

    <img
      src={feature.icon}
      alt={feature.title}
      className="relative z-10 h-[42px] w-[42px] object-contain"
    />
  </div>
</div>
                </div>
              ))}
            </div>
          </div>
        </div>

       
        <div className="flex bg-[#3E679B] px-5 py-10 sm:px-10 lg:min-h-[620px] lg:px-14 lg:py-7 xl:px-[70px]">
          <div className="mx-auto w-full max-w-[470px] self-center">
            <div className="text-center text-white">
              <h3 className="font-host text-[22px] font-medium leading-tight sm:text-[24px]">
                Want to enjoy our day trip?
              </h3>

              <p className="mx-auto mt-2 max-w-[340px] font-poppins text-[13px] font-normal leading-[1.5] sm:text-[14px]">
                Please fill out the form below with
                <span className="block">questions or comments</span>
              </p>
            </div>

            <form
              onSubmit={handleSubmit}
              className="mt-5 rounded-[32px] bg-white px-6 py-7 sm:px-8 sm:py-8"
            >
              <div>
                <label
                  htmlFor="key-feature-name"
                  className="font-poppins text-[10px] font-semibold uppercase text-black"
                >
                  Your Name*
                </label>

                <input
                  id="key-feature-name"
                  name="name"
                  type="text"
                  required
                  className="mt-2 w-full border-0 border-b border-[#D5D5D5] bg-transparent pb-3 font-poppins text-[14px] text-black outline-none"
                />
              </div>

              <div className="mt-5">
                <label
                  htmlFor="key-feature-email"
                  className="font-poppins text-[10px] font-semibold uppercase text-black"
                >
                  Email Address*
                </label>

                <input
                  id="key-feature-email"
                  name="email"
                  type="email"
                  required
                  className="mt-2 w-full border-0 border-b border-[#D5D5D5] bg-transparent pb-3 font-poppins text-[14px] text-black outline-none"
                />
              </div>

              <div className="mt-5">
                <label
                  htmlFor="key-feature-phone"
                  className="font-poppins text-[10px] font-semibold uppercase text-black"
                >
                  Phone Number (Optional)
                </label>

                <input
                  id="key-feature-phone"
                  name="phone"
                  type="tel"
                  className="mt-2 w-full border-0 border-b border-[#D5D5D5] bg-transparent pb-3 font-poppins text-[14px] text-black outline-none"
                />
              </div>

              <div className="mt-5">
                <label
                  htmlFor="key-feature-message"
                  className="font-poppins text-[10px] font-semibold uppercase text-black"
                >
                  Message*
                </label>

                <textarea
                  id="key-feature-message"
                  name="message"
                  required
                  rows={4}
                  className="mt-2 w-full resize-none border-0 border-b border-[#D5D5D5] bg-transparent pb-2 font-poppins text-[14px] text-black outline-none"
                />
              </div>

              <div className="mt-5 flex justify-center">
                <button
                  type="submit"
                  className="min-w-[155px] rounded-full bg-[#211C1A] px-7 py-[12px] font-poppins text-[14px] font-medium text-white transition-transform duration-300 hover:-translate-y-0.5"
                >
                  Send Form
                </button>
              </div>
              {(submissionMessage || submissionError) && (
                <p
                  aria-live="polite"
                  className={`mt-4 text-center font-poppins text-[12px] ${
                    submissionError ? 'text-[#B42318]' : 'text-[#3E679B]'
                  }`}
                >
                  {submissionError || submissionMessage}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}